import Job from '../../models/Job'

export default {
    INIT_JOB (state, job) {
        state.job = new Job(job)
    },

    SET_JOB (state, attributes) {
        state.job.update(attributes)
    },

    SET_ASSETS (state, assets) {
        state.assets = assets
    },

    ADD_ASSET (state, assetToAdd) {
        if (!state.assets.some(asset => asset.id === assetToAdd.id)) {
            state.assets.unshift(assetToAdd)
        }
    },

    SET_MEMBERS (state, members) {
        state.members = members
    },

    ADD_MEMBER (state, member) {
        state.members.push(member)
    },

    REMOVE_MEMBER (state, memberId) {
        state.members = state.members.filter(member => member.id !== memberId)
    },

    SET_COMMENTS (state, comments) {
        state.comments.addItems(comments)
    },

    ADD_COMMENT (state, comment) {
        state.comments.items.push(comment)
    },

    ADD_PARENT_COMMENT (state, comment) {
        state.parentComment = comment
    },

    REMOVE_PARENT_COMMENT (state) {
        state.parentComment = null
    },

    ADD_REACTION (state, reaction) {
        let comment = state.comments.items.find((comment) => comment.id === reaction.comment_id)

        comment.reactions.push(reaction)
    },

    REMOVE_REACTION (state, { commentId, reactionId }) {
        let comment = state.comments.items.find((comment) => comment.id === commentId)

        comment.reactions = comment.reactions.filter((item) => item.id !== reactionId)
    }
}
